import React from 'react';
import Modal from '@/ctComponents/Modal';
import { useNotify } from 'react-admin';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import IconButton from '@/ctComponents/IconButton';
import { SaveApiResMessage } from '@/actions';

export const ReferralLinkModal = ({ data, show, setShow }) => {
  const notify = useNotify();
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(data.unique_referral_link);
      // notify('Link copied to clipboard!', { type: 'success' });
      SaveApiResMessage({
        title: 'Success',
        message: 'Link copied to clipboard!',
        mode: 'success',
      });
    } catch (err) {
      // notify('Failed to copy link', { type: 'error' });
      SaveApiResMessage({
        title: 'Error',
        message: 'Failed to copy link',
        mode: 'error',
      });
    }
  };

  return (
    <Modal
      noX
      minWidth="unset"
      show={show}
      notClose={true}
      children={
        <div>
          <div className="w-full mt-4 justify-center p-2 lg:p-6  lg:w-613 flex flex-col items-center overflow-y-auto border border-solid border-border-primary rounded shadow-sm ">
            <ReactSVG
              beforeInjection={(svg) => {
                svg.setAttribute('width', '32');
                svg.setAttribute('height', '32');
              }}
              src={Icons.checkTick}
            />
            <p className="text-inactive-text text-2xl font-bold mt-4 mb-1">
              Your personal referral link is ready
            </p>
            <span className="text-inactive-text text-base">
              Now all you have to do is send it to your friends
            </span>

            <div className=" mt-4 w-full flex items-center justify-center">
              <a
                href={data.unique_referral_link}
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-normal sm:whitespace-nowrap truncate mr-2 text-primary-blue text-base font-averta no-underline">
                {data.unique_referral_link}
              </a>

              <ReactSVG
                beforeInjection={(svg) => {
                  svg.setAttribute('width', '20');
                  svg.setAttribute('height', '20');
                  svg.setAttribute(
                    'style',
                    'cursor: pointer; transition: stroke 0.2s ease;'
                  );
                  svg.addEventListener('mouseenter', () => {
                    const paths = svg.querySelectorAll('path');
                    paths.forEach((path) => {
                      path.style.stroke = '#F2AC4A';
                    });
                  });
                  svg.addEventListener('mouseleave', () => {
                    const paths = svg.querySelectorAll('path');
                    paths.forEach((path) => {
                      path.style.stroke = '';
                    });
                  });
                }}
                src={Icons.copy}
                onClick={copyToClipboard}
              />
            </div>
          </div>
          <div className="flex justify-end mt-5">
            <IconButton
              text={'Close'}
              style={{
                width: 120,
                height: 40,
                borderRadius: 4,
                borderColor: '#000000',
              }}
              onClick={() => {
                setShow(false);
              }}
            />
          </div>
        </div>
      }
      icon={'link'}
      title="Referral Link"
      setShow={setShow}
    />
  );
};
